import { Preset, PresetDefinition } from './Preset.interface';

export const DEFAULT_PRESET: Preset = 'DevisMRH';

/**
 * Definition of the PRESETS available in the application.
 * We should never rely on the direct value in the features and other components.
 * For example something like if (preset === 'MicroEnt') is forbidden.
 * We should always use the 'abstract' capabilities that are defined below.
 */
export const PRESETS: Record<Preset, PresetDefinition> = {
    DevisMRH: {
        type: 'DevisMRH',
        initialStep: 'LogementType',
        screens: {
            contact: {
                displayHelpButton: false,
                displayPreviousButton: true,
            },
        },
        stepper: {
            data: {
                'LogementType': {
                    activeStep: 0,
                    stepProgress: 0,
                },
                'LogementNombrePieces': {
                    activeStep: 0,
                    stepProgress: 20,
                },
                'LocataireType': {
                    activeStep: 0,
                    stepProgress: 40,
                },
                'LogementResidencePrincipale': {
                    activeStep: 0,
                    stepProgress: 60,
                },
                'LogementAdresse': {
                    activeStep: 0,
                    stepProgress: 80,
                },
                'LogementDebutAssurance': {
                    activeStep: 0,
                    stepProgress: 100,
                },
                'Contact': {
                    activeStep: 1,
                    stepProgress: 50,
                },
                'PreChooseAdvisor': {
                    activeStep: 1,
                    stepProgress: 100,
                },
                'ChooseAdvisor': {
                    activeStep: 1,
                    stepProgress: 100,
                },
                'PreConfirmation': null,
                'End/Confirmation': null,
                'End/AxaPartner': null,
                'End/Reject': null,
                'End/Unreliable-contact-information': null,
                'End/Apart-from-metropolis': null,
                'End/Rejet-sec': null,
                'End/Out-of-bounds': null,
                'End/Insurance': null,
                'End/Off-target-product': null,
                'Error': null,
                'Scenarios': null,
            },
            steps: [
                'Votre logement',
                'Vos coordonnées',
                'Confirmation',
            ],
        },
    },
    DevisPP: {
        type: 'DevisPP',
        initialStep: 'PreContact',
        screens: {
            contact: {
                displayHelpButton: false,
                displayPreviousButton: false,
            },
        },
        stepper: {
            data: {
                'PreContact': {
                    activeStep: 1,
                    stepProgress: 50,
                },
                'Contact': {
                    activeStep: 1,
                    stepProgress: 50,
                },
                'PreChooseAdvisor': {
                    activeStep: 2,
                    stepProgress: 100,
                },
                'ChooseAdvisor': {
                    activeStep: 2,
                    stepProgress: 100,
                },
                'PreConfirmation': null,
                'End/Confirmation': null,
                'End/AxaPartner': null,
                'End/Reject': null,
                'End/Unreliable-contact-information': null,
                'End/Apart-from-metropolis': null,
                'End/Rejet-sec': null,
                'End/Out-of-bounds': null,
                'End/Insurance': null,
                'End/Off-target-product': null,
                'Error': null,
                'Scenarios': null,
            },
            steps: [
                'Votre besoin',
                'Vos coordonnées',
                'Confirmation',
            ],
        },
    },
};

/**
 * Select the preset or fallbacks on the default value (@see DEFAULT_PRESET)
 * @param value
 * @returns
 */
export function selectPreset(value: Preset | string | undefined): PresetDefinition {
    if (!value) {
        return PRESETS[ DEFAULT_PRESET ];
    }

    return PRESETS[ value as Preset ] || PRESETS[ DEFAULT_PRESET ];
}
